module.exports = __webpack_public_path__ + "img/芭芭农场示例图.7e7944e6.jpeg";